document.querySelectorAll(".accordion-button").forEach((button) => {
  button.addEventListener("click", function () {
    const accordion = this.parentElement;
    accordion.classList.toggle("open");

    const content = accordion.querySelector(".accordion-content");
    if (accordion.classList.contains("open")) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = 0;
    }
  });
});
